import React from 'react';

export const CompanyBuildingIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Business">
            <g id="Vector">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 3H12V7H22V21H2V3ZM10 7V5H8V7H10ZM8 9V11H10V9H8ZM6 7V5H4V7H6ZM4 9V11H6V9H4ZM4 13V15H6V13H4ZM8 13V15H10V13H8ZM10 17H8V19H10V17ZM12 19H20V9H12V19ZM6 19V17H4V19H6Z"
                    fill="inherit"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 11H14V13H12V11Z"
                    fill="inherit"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 15H14V17H12V15Z"
                    fill="inherit"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 11H18V13H16V11Z"
                    fill="inherit"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 15H18V17H16V15Z"
                    fill="inherit"
                />
            </g>
        </g>
    </svg>
);
